import {
    Fade,
    Text,
    TextTag,
    TokenTextAppearance,
    TokenTextColor,
} from '@volkswagen-onehub/components-core'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {TitleContainer, TitleWrapper} from '../../shared/styled'
import {Faq} from '../components/Faq'
import {Global} from '../../shared/variables'
import {useSelector} from 'react-redux'
import {RootState} from '../rootReducer'

export function NoSimulations(): React.JSX.Element {
    const {t} = useTranslation('fa-flotte')
    const serviceType = useSelector(
        (state: RootState) => state.general.serviceType
    )
    const isPrivate = serviceType === Global.PRIVATE

    return (
        <>
            <Fade duration={300}>
                <TitleContainer>
                    <TitleWrapper>
                        <Text
                            tag={TextTag.span}
                            appearance={TokenTextAppearance.headline300}
                            color={TokenTextColor.primary}
                        >
                            {t('results.noSimulations')}
                        </Text>
                    </TitleWrapper>
                </TitleContainer>
            </Fade>
            {isPrivate && <Faq></Faq>}
        </>
    )
}
